import HealthCareItem from 'components/healthCare/HealthCareItem'

const HealthCare = () => {
  return <HealthCareItem />
}

export default HealthCare
